import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { Info } from 'lucide-react';
import type { FC, ReactNode } from 'react';

/** One label/value row. Every field in the document form is one of these — same label column, always. */
export const FormRow: FC<{ label: string; hint?: ReactNode; children: ReactNode }> = ({ label, hint, children }) => (
    <div className="grid grid-cols-[7rem_minmax(0,1fr)] items-start gap-3">
        <span className="flex items-center gap-1 pt-1.5 text-sm font-medium text-muted-foreground">
            {label}
            {hint && <InfoHint>{hint}</InfoHint>}
        </span>
        <div className="min-w-0">{children}</div>
    </div>
);

/** A hoverable ⓘ next to a field label: where a field's prose lives instead of above it. */
const InfoHint: FC<{ children: ReactNode }> = ({ children }) => (
    <Tooltip>
        <TooltipTrigger asChild>
            <button type="button" aria-label="More information" className="text-muted-foreground hover:text-foreground">
                <Info className="h-3.5 w-3.5" />
            </button>
        </TooltipTrigger>
        <TooltipContent className="max-w-[340px] leading-snug">{children}</TooltipContent>
    </Tooltip>
);
